import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetChainTypeOptions = (context: ProductBuilderMachineContext) => string[];

export const getChainTypeOptions: GetChainTypeOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { chain_type },
  } = baseProduct;
  return chain_type ? chain_type : [];
};
